const SIGN_IN_ACTION = {
  SET_SIGN_IN_DETAILS: "SET_SIGN_IN_DETAILS",
  SET_SIGN_UP_DETAILS: "SET_SIGN_UP_DETAILS",
  SET_TEMP_TOKEN_FOR_REQUEST_OTP: "SET_TEMP_TOKEN_FOR_REQUEST_OTP",
  PERSIST_LOGIN_STATE: "PERSIST_LOGIN_STATE",
  PERSIST_LOGGED_IN_STATUS: "PERSIST_LOGGED_IN_STATUS"
};
export default SIGN_IN_ACTION;
